import React from 'react';
import axios from 'axios';
import { Loading, ToastNotification } from 'carbon-components-react';
import { t } from '../../../RI18n';
import './ReportStatus.css';
import getStatusForCount from './CountStatus';

class ReportStatusWithRowCount extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reportItem: props.reportItem,
      reportRowCount: null,
      reportStatus: '',
      error: null,
      isLoaded: false,
    };
    this.signal = axios.CancelToken.source();
  }

  componentDidMount() {
    const { reportItem } = this.state;
    const countHref = reportItem.count_href;
    const statusIntervals = {
      success: reportItem.status_green,
      warning: reportItem.status_yellow,
      error: reportItem.status_red,
      info: reportItem.status_blue,
    };

    axios
      .get(countHref, {
        cancelToken: this.signal.token,
      })
      .then((result) => {
        this.setState({
          reportRowCount: result.data.total,
          isLoaded: true,
          reportStatus: getStatusForCount(result.data.total, statusIntervals),
        });
      })
      .catch((err) => {
        if (axios.isCancel(err)) return; // request aborted
        if (!err.response && !err.status) {
          // TODO investigate Network error when click on report link
          // while request for report count is not finished (isLoaded: false)
          return;
        }
        console.log(err);
        this.setState({
          error: true,
          isLoaded: true,
        });
        this.props.errorInReportItem(err.message);
      });
  }

  componentWillUnmount() {
    this.signal.cancel();
  }

  render() {
    const {
      reportItem,
      reportRowCount,
      reportStatus,
      error,
      isLoaded,
    } = this.state;

    const reportLink = (
      <a
        href={reportItem.href}
        className="bx--link, ReportStatusWithRowCount-title"
        onClick={() => {
          this.signal.cancel();
        }}
      >
        {reportItem.name}
      </a>
    );

    let renderedReportStatusText = '';
    let reportCount = '';

    if (error) {
      renderedReportStatusText = t('widget.status.unknown');
      reportCount = (
        <div
          className="ReportStatusWithRowCount-unknown-count"
          title={renderedReportStatusText}
        >
          {renderedReportStatusText}
        </div>
      );
    } else if (isLoaded) {
      renderedReportStatusText = t(`widget.status.${reportStatus}`);
      reportCount = (
        <h3
          className="ReportStatusWithRowCount-count"
          title={renderedReportStatusText}
        >
          {reportRowCount}
        </h3>
      );
    } else {
      renderedReportStatusText = t('widget.status.loading');
      reportCount = <Loading small withOverlay={false} />;
    }

    return (
      <div className="bx--col-xs-12 bx--col-sm-6 bx--col-md-4 bx--col-lg-3 bx--col-xl-2">
        <ToastNotification
          className="ReportStatusWithRowCount-toast-notification"
          key={this.props.listIndex}
          id={`widget_${this.props.listIndex}`}
          title={reportLink}
          subtitle={reportCount}
          caption=""
          hideCloseButton
          kind={reportStatus}
          aria-label={t('widget.aria_label', {
            index: this.props.listIndex + 1,
            status: renderedReportStatusText,
          })}
          role="region"
        />
      </div>
    );
  }
}

export default ReportStatusWithRowCount;
